import { render, staticRenderFns } from "./detailContract.vue?vue&type=template&id=52342038&scoped=true"
import script from "./detailContract.vue?vue&type=script&lang=js"
export * from "./detailContract.vue?vue&type=script&lang=js"
import style0 from "./detailContract.vue?vue&type=style&index=0&id=52342038&prod&lang=css"
import style1 from "./detailContract.vue?vue&type=style&index=1&id=52342038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52342038",
  null
  
)

export default component.exports